export default "__VITE_ASSET__CH$AGoPn__"